import { render, staticRenderFns } from "./CCPA_Success.vue?vue&type=template&id=8bf4333a"
import script from "./CCPA_Success.vue?vue&type=script&lang=js"
export * from "./CCPA_Success.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports